<div class="container">
  <div
    class="mt-2 d-flex align-items-center"
  >
    <a href="https://izglitiba.daugavpils.lv" class="link-unstyled"><img src="/dpip-logo.png" class="img-responsive" height="30"></a>
    <h6 class="text-uppercase ms-3 mb-0 text-secondary"><a href="https://izglitiba.daugavpils.lv" class="link-unstyled">Daugavpils pilsētas <br class="d-inline d-sm-none">Izglītības pārvalde</a></h6>
  </div>
  <div class="mt-3">
    <slot></slot>
  </div>
  <div class="small">
    <a href="" class="text-muted">Privātuma politika</a>
    <a href="#" class="text-muted" data-cc="c-settings">Sīkdatņu iestatījumi</a>
  </div>
</div>

<style>
.link-unstyled {
  text-decoration: none;
  color: inherit;
}
</style>
